import React from 'react'

const MessageSendingIcon = () => {
    return (
        <svg fill="#808080" width="12" height="12" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" class="jam jam-circle"><path d='M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z'/></svg>
    )
}

export default MessageSendingIcon